export default {
  en: {
    supplier: {
      title: 'Supplier mode',
      tooltip: 'Click to switch to supplier mode',
    },
    becomeSupplier: {
      tooltip: 'Click to become a supplier',
      title: 'Become a supplier',
      subTitle:
        '<b>Complete the last supplier due diligence assessment you should <br> ever have to do — with Risk Ledger.</b>',
      oldBody:
        'Becoming a supplier on the Risk Ledger platform will allow you to complete one security and  procurement assessment that you can securely and efficiently share with any client that requires you to take part in their third-party risk management programme. <p /> it is completely <b>free</b> to use the supplier side of the Risk Ledger platform so join suppliers like Stripe and CrowdStrike today.',
      body: 'Becoming a supplier on the Risk Ledger platform will allow you to complete one security and  procurement assessment that you can securely and efficiently share with any client that requires you to take part in their third-party risk management programme. <p /> it is completely <b>free</b> to use the supplier side of the Risk Ledger platform so join suppliers like Stripe and CrowdStrike today. Your connected clients will be able to see the names of your own suppliers in their network visualisation. You can disable this at any time in your settings.',
      button: 'Become supplier',
      requestDemo:
        'I am interested in scheduling a demo and learning more about the Risk Ledger platform as a supplier',
    },
    client: {
      title: 'Client mode',
      tooltip: 'Click to switch to client mode',
    },
    federated: {
      title: 'Federated mode',
    },
    switcher: {
      tooltip: 'Switch mode',
    },
    becomeClient: {
      tooltip: 'Click to become a client',
      title: 'See your supply chain security the way your clients do',
      subTitle:
        "Since you're already using Risk Ledger as a supplier, why not try the client side? Use the same platform to assess your own suppliers:",
      features:
        '<li>Quickly connect to your suppliers - many already on the platform</li>\n        <li>Evaluate suppliers using the same assessment framework you are used to</li>\n        <li>Collaborate with your team on suppliers reviews</li>\n        <li>Visualise the health of your direct supply chain and fourth parties</li>',
      button: 'Try it out',
      requestDemo:
        'I am interested in scheduling a demo and learning more about the Risk Ledger platform as a client',
    },
    misc: {
      knowledgeBase: 'Knowledge base',
      knowledgeBaseTooltip: 'Learn more about suppliers',
      laterButton: 'Maybe later',
      requestDemo: 'Learn more',
      error: 'Failed to set organisation type. Please try again.',
      noPermission:
        'Please contact your organisation Lead or Admin to request access for the {0} side of the Risk Ledger platform.',
    },
    tryItOut: {
      title: "You respond to security reviews. Now assess your suppliers' compliance.",
      cta: 'Try it out',
    },
    gettingStarted: {
      hero: {
        title: 'Respond to security questions faster with Risk Ledger',
        text: 'Complete once, share with your clients and never complete a questionnaire from scratch again.',
        link: 'Learn more about Risk Ledger',
      },
      quickStartTitle: 'Quick start',
      quickStartText: 'Up and running in 10 minutes',
      nCompleted: '{n}/{total} completed',
      scopingTitle: 'Answer a few quick questions to tailor your assessment',
      scopingText:
        'This means you only see questions that are relevant to your organisation, making the process more focused and manageable.',
      quickAnswerTitle: 'Save time with auto-suggest',
      quickAnswerText:
        "Upload documents you already have, like ISO certificates, data policies, or past questionnaires. We'll suggest answers, so you don't need to start from scratch.",
      addColleagueTitle: 'Add a colleague',
      addColleagueText:
        'Need input from someone else? Invite a colleague to help you answer the questions.',
      doneTitle: 'Quick start complete',
      doneSubtitle: "You're ready to begin your assessment.",
      skipTitle: 'Ready to get started?',
      skipText:
        'Skip setup and jump straight into your assessment. You can return to this page anytime.',
      continueTitle: 'Continue your assessment',
      continueText:
        "You've already started your assessment. Jump back in and finish when you're ready. You can return anytime.",
      startAssessment: 'Start assessment',
      continueAssessment: 'Continue assessment',
      goAssessment: 'Continue to assessment',
      securityProfile: {
        title: 'Claim your free supplier profile',
        invitedByOneText: "You've been requested by {inviter} to complete your supplier profile",
        invitedByManyText:
          "You've been requested by {number} clients to complete your supplier profile",
        invitedByNoneText:
          'Fill out your security information so you can share your security posture with your clients',
      },
      addUsers: {
        title: 'Need help? Add your colleagues',
        text: 'Add people within your organisation to help you fill out your profile',
        button: 'Add users',
      },
      otherFeatures: {
        title: 'Other available features',
        description:
          'Once you have completed your security profile you will unlock more features in Risk Ledger',
      },
      trustCentres: {
        title: 'Shareable Trust Centres',
        description: 'Share security posture information with your prospective clients.',
        cta: 'View',
      },
      externalMonitoring: {
        title: 'Monitor your public domains',
        description:
          'Get visibility into vulnerabilities in your public assets that your clients will see.',
        cta: 'View',
      },
    },
  },
};
